import { render } from "./detallePost.vue?vue&type=template&id=01953c04"
import script from "./detallePost.vue?vue&type=script&lang=js"
export * from "./detallePost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__